import {AnyCommand, PREPARE_JOB_SECTIONS_IMPORT_COMMAND, PrepareJobSectionsImportCommand} from '../type';

export default function prepareJobPagesImport(payload: PrepareJobSectionsImportCommand['payload']): AnyCommand {
  return {
    type: PREPARE_JOB_SECTIONS_IMPORT_COMMAND,
    payload,
  }
}